module.exports = __webpack_public_path__ + "assets/img/instagram_1024.4385a547.png";